export const hashNumbers = (...values: number[]): number => {
  let hash = 0;
  for (let i = 0; i < values.length; i++) {
    /* tslint:disable:no-bitwise */
    hash = (hash << 5) - hash + values[i];
    hash = hash & hash; // Convert to 32bit integer
    /* tslint:enable:no-bitwise */
  }
  return hash;
};

export const hashString = (str: string): number =>
  hashNumbers(...str.split('').map(char => char.charCodeAt(0)));
